<template>
  <div>
    <zj-layout-container>
      <zj-layout-main>
        <div class="zj-vehicleview-root select-none">
          <MapView
            MapKey="MobileHotMap"
          ></MapView>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import MapView from "./components/MapView";

export default {
  name: "MobileHotMapView",
  componentName: "MobileHotMapView",
  components: {
    MapView,
  },
  controller: "Home",
  action: "MobileHotMapView",
  data() {
    return {
      isVideoMonitorDialogVisible: false,
      streamType: 1, //0 - 主码流；1 - 子码流
      autoplay: false,
      cameraId: "",
      cameraName:""
    };
  },
  methods: {
    layerButtonClick: function(data) {
      let e = data.e;
      switch (data.action) {
        case "videomonitor":
          this.cameraId = e.data.DeviceId;
          this.cameraName = e.data.DeviceName;
          this.isVideoMonitorDialogVisible = true;
          break;
        default:
          this.$message({ type: "warning", message: data.action + "未实现" });
          break;
      }
    },
  },
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
}
</style>
